import React, { useState, useEffect, useRef } from "react";
import Grid from '@material-ui/core/Grid';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Close from '@material-ui/icons/Close';
import { Snackbar } from '@material-ui/core';
import Modal from "react-modal";
import Cookies from 'js-cookie';
import moment from 'moment';
import api from '../../../../../../services/api';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import ReplayIcon from '@mui/icons-material/Replay';

// Standardized Leaflet Integration
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

import icone_central from '../../../../../../assets/imgs/icone_central.png';
import icone_armar_stay from '../../../../../../assets/imgs/armar_stay.png';
import icone_armar_away from '../../../../../../assets/imgs/armar_away.png';
import icone_desarmar from '../../../../../../assets/imgs/desarmar.png';
import icone_reiniciar from '../../../../../../assets/imgs/icone_reiniciar.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

export default function CentralComponent(props) {
    const { lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, flag } = props;
    const tempoInativo = 3;

    // Dark mode state and theme config
    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const handleThemeChange = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        const intervalId = setInterval(handleThemeChange, 1000);
        window.addEventListener('storage', handleThemeChange);
        window.addEventListener('themeChange', handleThemeChange);
        window.addEventListener('darkModeChanged', handleThemeChange);
        window.addEventListener('temaChanged', handleThemeChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('storage', handleThemeChange);
            window.removeEventListener('themeChange', handleThemeChange);
            window.removeEventListener('darkModeChanged', handleThemeChange);
            window.removeEventListener('temaChanged', handleThemeChange);
        };
    }, []);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    // Control for Map Hover display without breaking React-Leaflet Context
    const [showMap, setShowMap] = useState(false);
    const [mapReady, setMapReady] = useState(false);
    const mapRef = useRef(null);

    useEffect(() => {
        setMapReady(true);
    }, []);

    // Manual Leaflet init to avoid Context Errors
    useEffect(() => {
        if (showMap && mapReady && mapRef.current && (equipamento.modulo_pgm?.latitude || lat)) {
            const mapLat = parseFloat(equipamento.modulo_pgm?.latitude || lat);
            const mapLng = parseFloat(equipamento.modulo_pgm?.longitude || lng);
            
            const timeoutId = setTimeout(() => {
                if (!mapRef.current) return;
                
                const map = L.map(mapRef.current).setView([mapLat, mapLng], 16);
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap'
                }).addTo(map);
                
                L.marker([mapLat, mapLng]).addTo(map);
                
                return () => {
                    map.remove();
                };
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [showMap, mapReady, equipamento.modulo_pgm?.latitude, equipamento.modulo_pgm?.longitude, lat, lng]);

    // Map Modal State
    const [openModalMap, setOpenModalMap] = useState(false);
    const modalMapRef = useRef(null);

    // Modal Map Init
    useEffect(() => {
        if (openModalMap && modalMapRef.current) {
            const mapLat = parseFloat(equipamento.modulo_pgm?.latitude || lat);
            const mapLng = parseFloat(equipamento.modulo_pgm?.longitude || lng);

            const timeoutId = setTimeout(() => {
                if (!modalMapRef.current) return;
                
                const map = L.map(modalMapRef.current).setView([mapLat, mapLng], 14);
                
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap'
                }).addTo(map);

                L.marker([mapLat, mapLng]).addTo(map)
                    .bindPopup(`<b>${equipamento.nome_mapa}</b><br/>Localização da Central`)
                    .openPopup();

                return () => {
                    map.remove();
                };
            }, 400); 

            return () => clearTimeout(timeoutId);
        }
    }, [openModalMap, lat, lng, equipamento.nome_mapa, equipamento.modulo_pgm]);

    async function handleClickCentral(comando) {
        try {
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            let url = "";
            if (equipamento.modulo_pgm && parseInt(equipamento.modulo_pgm.id_modulo_pgm) > 0) {
                url = `/v1/protected/modulopgm/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/" + comando;
            } else if (equipamento.modulo_sonoro && parseInt(equipamento.modulo_sonoro.id_modulo_sonoro) > 0) {
                url = `/v1/protected/modulosonoro/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_sonoro.id_modulo_sonoro + "/" + comando + "/0/0/0/0/0/0/0/0";
            } else {
                setSnackbarMessage('Nenhum Módulo associado a Central');
                setSnackbarSeverity('warning');
                setSnackbarOpen(true);
                return;
            }
            const response = await api.get(url, { headers });

            if (response.data) {
                setSnackbarMessage('Comando Enviado!');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
            }
        } catch (error) {
            setSnackbarMessage('Erro ao enviar comando');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            console.error("Erro ao enviar o comando:", error);
        }
    }

    // Calcular a diferença de tempo baseada no módulo vinculado
    const modulo = equipamento.modulo_pgm || equipamento.modulo_sonoro;
    const lastResponse = modulo ? new Date(modulo.data_hora_ultima_resposta) : new Date();
    const differenceInMinutes = (new Date() - lastResponse) / 1000 / 60;

    let statusText = differenceInMinutes < tempoInativo ? "CONECTADA" : "OFFLINE";
    let statusColor = differenceInMinutes < tempoInativo ? "#10b981" : "#ef4444";
    let isBlinking = differenceInMinutes >= tempoInativo;

    return (
        <>
            {flag === 1 ? (
                <div style={{
                    backgroundColor: darkMode ? '#0f172a' : '#f8fafc',
                    borderRadius: '16px',
                    padding: '24px',
                    width: '100%',
                    fontFamily: '"Rajdhani", "Roboto", "Segoe UI", sans-serif',
                    boxShadow: darkMode ? '0 10px 40px rgba(0,0,0,0.5)' : '0 10px 40px rgba(0,0,0,0.08)',
                    border: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0',
                }}>
                    {/* HEADER IOT */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0', paddingBottom: '16px', marginBottom: '24px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img src={icone_central} alt="icon" style={{ width: '48px', height: '48px', position: 'relative', zIndex: 2, filter: darkMode ? 'invert(1)' : 'none' }} />
                                <div style={{
                                    position: 'absolute', width: '56px', height: '56px', borderRadius: '50%',
                                    backgroundColor: statusColor, opacity: 0.2, animation: isBlinking ? 'blink 2s infinite' : 'none', zIndex: 1
                                }} />
                            </div>
                            <div>
                                <Typography style={{ fontWeight: 800, fontSize: '1.4rem', letterSpacing: '0.5px', color: darkMode ? '#f8fafc' : '#0f172a', lineHeight: 1.2 }}>
                                    CENTRAL DE ALARME <span style={{ color: '#8b5cf6', fontSize: '0.7rem', backgroundColor: 'rgba(139, 92, 246, 0.1)', padding: '2px 8px', borderRadius: '12px', verticalAlign: 'middle', marginLeft: '8px', border: '1px solid rgba(139, 92, 246, 0.2)' }}>SISTEMA ATIVO</span>
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                                    <Typography style={{ fontSize: '0.85rem', color: darkMode ? '#94a3b8' : '#64748b', fontFamily: 'monospace' }}>
                                        VÍNCULO: {modulo ? modulo.codigo : 'SEM MÓDULO'}
                                    </Typography>

                                    {(modulo?.latitude || lat) && (
                                        <div 
                                            style={{ position: 'relative' }}
                                            onMouseEnter={() => setShowMap(true)}
                                            onMouseLeave={() => setShowMap(false)}
                                            onClick={() => setOpenModalMap(true)}
                                        >
                                            <div style={{ 
                                                display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer',
                                                backgroundColor: darkMode ? 'rgba(56, 189, 248, 0.1)' : 'rgba(14, 165, 233, 0.1)',
                                                padding: '2px 8px', borderRadius: '12px', border: darkMode ? '1px solid rgba(56, 189, 248, 0.2)' : '1px solid rgba(14, 165, 233, 0.2)',
                                                transition: 'all 0.2s ease-in-out'
                                            }}>
                                                <LocationOnIcon style={{ fontSize: '0.9rem', color: darkMode ? '#38bdf8' : '#0ea5e9' }} />
                                                <Typography style={{ fontSize: '0.65rem', fontWeight: 800, color: darkMode ? '#38bdf8' : '#0ea5e9', letterSpacing:'0.5px' }}>
                                                    LOCALIZAÇÃO
                                                </Typography>
                                            </div>

                                            {showMap && mapReady && (
                                                <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 11000, width: '320px', paddingTop: '8px' }}>
                                                    <div style={{
                                                        padding: '8px', borderRadius: '8px', backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                                        boxShadow: '0 10px 25px rgba(0,0,0,0.5)', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0'
                                                    }}>
                                                        <div ref={mapRef} style={{ height: '180px', width: '100%', borderRadius: '8px', overflow:'hidden', backgroundColor:'#f0f0f0' }} />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px' }}>
                            <div style={{ 
                                backgroundColor: `${statusColor}15`, color: statusColor, padding: '6px 16px', borderRadius: '24px',
                                border: `1px solid ${statusColor}30`, fontWeight: 700, fontSize: '0.8rem', letterSpacing: '0.5px',
                                display: 'flex', alignItems: 'center', gap: '6px'
                            }}>
                                {isBlinking && <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: 'currentColor', animation: 'blink 1s step-start infinite' }}/>}
                                {statusText}
                            </div>
                            <Typography style={{ fontSize: '0.7rem', color: darkMode ? '#64748b' : '#94a3b8', fontFamily: 'monospace' }}>
                                ÚLT. SINCRONISMO: {modulo?.data_hora_ultima_resposta ? moment(modulo.data_hora_ultima_resposta, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss DD/MM/YY") : 'N/A'}
                            </Typography>
                        </div>
                    </div>

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <div style={{
                                backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                borderRadius: '12px',
                                border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                padding: '20px',
                                boxShadow: darkMode ? 'inset 0 2px 10px rgba(0,0,0,0.2)' : '0 2px 10px rgba(0,0,0,0.02)'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
                                    <SettingsInputAntennaIcon style={{ color: '#8b5cf6' }} />
                                    <Typography style={{ fontWeight: 800, fontSize: '0.9rem', color: darkMode ? '#f1f5f9' : '#1e293b', letterSpacing: '1px' }}>CANAIS DE CONTROLE</Typography>
                                </div>
                                <Grid container spacing={2}>
                                    {[ 
                                        { label: 'Armar em Stay', cmd: 27, icon: icone_armar_stay, color: '#f59e0b' },
                                        { label: 'Armar em Away', cmd: 28, icon: icone_armar_away, color: '#ef4444' },
                                        { label: 'Desarmar Central', cmd: 29, icon: icone_desarmar, color: '#10b981' },
                                        { label: 'Reiniciar Central', cmd: 223, icon: icone_reiniciar, color: '#3b82f6' }
                                    ].map((btn) => (
                                        <Grid item xs={12} sm={6} md={3} key={btn.cmd}>
                                            <div 
                                                onClick={() => handleClickCentral(btn.cmd)}
                                                style={{
                                                    backgroundColor: darkMode ? '#0f172a' : '#f8fafc',
                                                    border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                                    borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '12px',
                                                    cursor: 'pointer', transition: 'all 0.2s', elevation: 2,
                                                    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
                                                    '&:hover': { transform: 'translateY(-2px)', borderColor: btn.color }
                                                }}
                                            >
                                                <div style={{ backgroundColor: `${btn.color}15`, padding: '8px', borderRadius: '10px' }}>
                                                    <img src={btn.icon} style={{ width: '24px', height: '24px' }} alt={btn.label} />
                                                </div>
                                                <Typography style={{ fontSize: '0.85rem', fontWeight: 700, color: darkMode ? '#f1f5f9' : '#1e293b' }}>{btn.label}</Typography>
                                            </div>
                                        </Grid>
                                    ))}
                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            ) : (
                <Grid container direction="row" justifyContent="center" align="center" item xs={3} style={{ padding: 1, margin: 0 }}>
                    <Grid container direction="row" justifyContent="center" align="center" item xs={12}>
                        <Grid item xs={12}>
                            <img alt={"icone"} style={{ textAlign: 'center', width: '40px', height: '40px', filter: darkMode ? 'invert(1)' : 'none' }} src={icone_central} />
                        </Grid>
                        <Grid item xs={12}>
                            <span style={{ color: darkMode ? '#f8fafc' : '#0f172a', fontSize: '12px', fontWeight: '800', letterSpacing: '0.5px' }}>{equipamento.nome_mapa} </span>
                        </Grid>
                        <Grid item xs={12}>
                            <span style={{ color: statusColor, fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', animation: isBlinking ? 'blink 2s step-start infinite' : 'none' }}>
                                {statusText}
                            </span>
                        </Grid>
                    </Grid>
                </Grid>
            )}

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                ContentProps={{
                    style: {
                        backgroundColor: snackbarSeverity === 'success' ? '#10b981' : (snackbarSeverity === 'warning' ? '#f59e0b' : '#ef4444'),
                        marginTop: '60px', fontSize: '16px', fontWeight: 'bold', borderRadius: '8px'
                    }
                }}
            />

            <Modal
                isOpen={openModalMap}
                onRequestClose={() => setOpenModalMap(false)}
                style={{
                    content: {
                        top: '50%', left: '50%', right: 'auto', bottom: 'auto',
                        marginRight: '-50%', transform: 'translate(-50%, -50%)',
                        width: '90%', maxWidth: '900px', height: '80vh',
                        padding: '0', borderRadius: '12px', overflow: 'hidden',
                        backgroundColor: darkMode ? '#0f172a' : '#fff', border: 'none'
                    },
                    overlay: { backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 10000 }
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div style={{ padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: darkMode ? '#1e293b' : '#f8fafc', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0' }}>
                        <Typography style={{ fontWeight: 800, color: darkMode ? '#f1f5f9' : '#1e293b' }}>LOCALIZAÇÃO - {equipamento.nome_mapa}</Typography>
                        <IconButton onClick={() => setOpenModalMap(false)} size="small" style={{ color: darkMode ? '#94a3b8' : '#64748b' }}><Close /></IconButton>
                    </div>
                    <div style={{ flex: 1, position: 'relative' }}><div ref={modalMapRef} style={{ width: '100%', height: '100%' }} /></div>
                </div>
            </Modal>
            
            <style>{`
                @keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }
            `}</style>
        </>
    );
}
